// extracted by mini-css-extract-plugin
module.exports = {"category-name-label":"category-name-label___1vR7y"};